import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Layout, Row, Col, Modal, Tabs, Spin, Input } from 'antd';
import { Icon, Toast, Picker, List, Modal as ModalMobile } from 'antd-mobile'
import * as SignalR from '@aspnet/signalr';
import basketImage from '../../assets/image/Icon/BasketCart.svg';
import AmenityDetailModal from './amenityDetailModal';
import AmenityTabPage from './amenityTab';
import { Markup } from 'interweave';
import IdleTimer from 'react-idle-timer';

const { Content } = Layout;
const { Search } = Input;
const { TabPane } = Tabs;
const confirmAlert = ModalMobile.alert;
const REACT_APP_SIGNALR_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/stayMenuHub`;

@inject(
    'VersionStore',
    'templateStore',
    'CmsLanguageStore',
    'popupStore',
    'amenityStore',
    'loginStore',
    'webSettingStore'
)
@observer
class AmenityMainPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        const roomNo = this.props.loginStore.getRoomNo();
        if (!roomNo) {
            this.props.history.push('/login');
        }

        this.props.loginStore.authenticateGuest().then(response => {
            if (!response) {
                this.props.history.push('/login');
            }
        });

        this.props.amenityStore.initTotalAmenityOrder(roomNo);
        this.props.amenityStore.setShowAmenityDetailModal(false);
        this.props.amenityStore.initGetAmenities(roomNo);

        this.props.CmsLanguageStore.getActives().then(() => {
            this.props.templateStore.getActive().then(() => {
                this.props.webSettingStore.getData().then(() => {
                    const { activeTemplate } = this.props.templateStore;
                    const { data: webSettting } = this.props.webSettingStore;

                    if (webSettting) {
                        this.props.popupStore.getByModuleName('AMENITY').then(resp => {
                            if (resp) {
                                if (resp.title) {
                                    confirmAlert(
                                        <div style={{
                                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                            color: activeTemplate.templateSetting.label.color,
                                            fontSize: activeTemplate.templateSetting.label.fontSize,
                                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                        }}>
                                            <span>{resp.title}</span>
                                        </div>,
                                        <div style={{
                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                            color: activeTemplate.templateSetting.text.color,
                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 8}px`
                                        }}>
                                            <Markup content={resp.description} />
                                        </div>,
                                        [
                                            {
                                                text: <span style={{
                                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                    color: activeTemplate.templateSetting.label.color,
                                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                                }}>OK</span>
                                            }
                                        ]);
                                }
                            }
                        });

                    }
                });
            });
        });

        let connection = new SignalR.HubConnectionBuilder().withUrl(REACT_APP_SIGNALR_URL).build();
        connection.start().catch(function (err) { return console.error(err.toString()); });
        connection.on(`SignalR_SyncData`, () => { window.location.reload(true); });
    }

    componentDidUpdate() {
        this.tabStyle();
        this.stepperStyle();
    }

    componentWillUnmount() {
        this.props.amenityStore.resetData();
    }

    tabStyle = () => {
        const { activeTemplate } = this.props.templateStore;

        const { data: webSettting } = this.props.webSettingStore;

        if (webSettting) {
            const tabs = document.getElementsByClassName('ant-tabs-tab');

            for (let i = 0; i < tabs.length; i++) {
                tabs[i].style.fontFamily = `${activeTemplate.templateSetting.tab.fontFamily}`;
                tabs[i].style.fontSize = `${activeTemplate.templateSetting.tab.fontSize}px`;
                tabs[i].style.lineHeight = `${activeTemplate.templateSetting.tab.fontSize + 2}px`;
                tabs[i].style.color = activeTemplate.templateSetting.tab.color;
            }

            const tabActives = document.getElementsByClassName('ant-tabs-tab-active');

            for (let i = 0; i < tabActives.length; i++) {
                tabActives[i].style.fontFamily = `${activeTemplate.templateSetting.tabSelected.fontFamily}`;
                tabActives[i].style.fontSize = `${activeTemplate.templateSetting.tabSelected.fontSize}px`;
                tabActives[i].style.lineHeight = `${activeTemplate.templateSetting.tabSelected.fontSize + 2}px`;
                tabActives[i].style.color = activeTemplate.templateSetting.tabSelected.color;
            }

            const tabInk = document.getElementsByClassName('ant-tabs-ink-bar');

            for (let i = 0; i < tabInk.length; i++) {
                tabInk[i].style.background = `${activeTemplate.templateSetting.tabSelected.color}`;
            }
        }
    }

    stepperStyle = () => {
        const { activeTemplate } = this.props.templateStore;

        const { data: webSettting } = this.props.webSettingStore;

        if (webSettting) {
            const steppers = document.getElementsByClassName('am-stepper-handler');

            for (let i = 0; i < steppers.length; i++) {
                steppers[i].style.fontFamily = `${activeTemplate.templateSetting.text.fontFamily}`;
                steppers[i].style.background = activeTemplate.templateSetting.header.backgroundColor;
                steppers[i].style.borderColor = activeTemplate.templateSetting.header.backgroundColor;
            }
        }
    }

    // ON CHANGE

    searchText = (e) => {
        this.props.amenityStore.setAmenitySearchText(e.target.value);
        this.props.amenityStore.searchAmenityByNameAndSubCategory();
    }

    selectBySubCategory = (subCategories) => {
        const subCategory = subCategories[0];
        this.props.amenityStore.setAmenitySearchSubCategory(subCategory);
        this.props.amenityStore.searchAmenityByNameAndSubCategory();
    }

    // ON CLICK

    goToConfirmPage = () => {
        const {
            amenityItems
        } = this.props.amenityStore;

        let orderAmenityItems = [];

        if (amenityItems) {
            if (amenityItems.length > 0) {
                orderAmenityItems = amenityItems.filter(fi => fi.orderQuantity > 0);
                const {
                    data: webSettting
                } = this.props.webSettingStore;

                if (orderAmenityItems.length === 0) {
                    Toast.fail(webSettting ? webSettting.pleaseSelectYourOrderText : '', 1);
                    return;
                }
            }
        }

        const roomNo = this.props.loginStore.getRoomNo();
        const amenityPendingOrders = this.props.amenityStore.goToAmenityConfirmPage(roomNo);

        if (amenityPendingOrders.length !== 0) {
            this.props.history.push('/amenity-confirm');
        }
    }

    back = () => {
        this.props.history.push('/');
    }

    // ON TAB CLICK

    tabClick = (key) => {
        const categoryTaskId = key.toString();
        this.props.amenityStore.setAmenityTabSubCategoriesByTabCategoryTaskId(categoryTaskId);
        this.props.amenityStore.setShowAmenityDetailModal(false);
        this.props.amenityStore.setAmenitySearchText('');
        this.props.amenityStore.setAmenitySearchSubCategory('All');
        this.props.amenityStore.searchAmenityByNameAndSubCategory();
    }

    // ON TOUCH

    _onTouchStart(e, that) {
        const touch = e.touches[0];
        that.props.amenityStore.setSwipeX(touch.clientX);
        that.props.amenityStore.setIsSwipe(false);
    }

    _onTouchMove(e, that) {
        if (e.changedTouches && e.changedTouches.length) {
            that.props.amenityStore.setIsSwipe(true);
        }
    }

    _onTouchEnd(e, that, categoryTaskId) {
        const { swipeX, isSwipe, amenityTabCategories } = that.props.amenityStore;
        const touch = e.changedTouches[0];
        const absX = Math.abs(touch.clientX - swipeX);
        if (isSwipe && absX > 50) {
            if (touch.clientX - swipeX < 0) {
                let nextCategoryTaskId = 0;
                for (let i = 0; i < amenityTabCategories.length; i += 1) {
                    if (amenityTabCategories[i].taskId === categoryTaskId) {
                        if (amenityTabCategories[i + 1]) {
                            nextCategoryTaskId = amenityTabCategories[i + 1].taskId;
                            that.tabClick(nextCategoryTaskId);
                        }
                        return;
                    }
                }
            } else {
                let prevCategoryTaskId = 0;
                for (let i = 0; i < amenityTabCategories.length; i += 1) {
                    if (amenityTabCategories[i].taskId === categoryTaskId) {
                        if (amenityTabCategories[i - 1]) {
                            prevCategoryTaskId = amenityTabCategories[i - 1].taskId;
                            that.tabClick(prevCategoryTaskId);
                        }
                        return;
                    }
                }
            }
        }

        that.props.amenityStore.setSwipeX(0);
        that.props.amenityStore.setIsSwipe(false);
    }

    checkSmVersion = () => {
        this.props.VersionStore.check().then(resp => {
            if (!resp) {
                const { activeTemplate } = this.props.templateStore;
                const { data: webSettting } = this.props.webSettingStore;

                confirmAlert(
                    <div
                        style={{
                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                            color: activeTemplate.templateSetting.label.color,
                            fontSize: activeTemplate.templateSetting.label.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                        }}>
                        <span>Info</span>
                    </div>,
                    <div
                        style={{
                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                            color: activeTemplate.templateSetting.text.color, fontSize: activeTemplate.templateSetting.text.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`, textAlign: 'center'
                        }}>
                        <span>New version has been released. Please refresh the page.</span>
                    </div>, [
                    {
                        text:
                            <span
                                style={{
                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                    color: activeTemplate.templateSetting.label.color,
                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                }}
                            >
                                {webSettting.okText}
                            </span>,
                        onPress: () => {
                            window.location.reload(true);
                        }
                    }
                ]);
            }
        });
    }

    render() {
        const { activeTemplate } = this.props.templateStore;

        const { data: webSettting } = this.props.webSettingStore;

        const {
            menu,
            showAmenityDetailModal,
            amenityTabCategories,
            amenityItems,
            amenityFilterItems,
            amenitySearchText,
            amenitySearchSubCategory,
            amenityTabSubCategories,
            amenityTabCategoryIdActive,
            amenityTotalOrder
        } = this.props.amenityStore;


        return (
            <>
                {
                    activeTemplate
                        ?
                        <>
                            <Layout className='stm-layout'>
                                <IdleTimer ref={ref => { this.idleTimer = ref }} timeout={1000 * 5} onIdle={this.checkSmVersion} debounce={250} />
                                <>
                                    {
                                        webSettting
                                            ?
                                            <>
                                                <Modal
                                                    className='stm-modal'
                                                    title='Amenity Detail'
                                                    onCancel={() => { this.props.amenityStore.setShowAmenityDetailModal(false) }}
                                                    visible={showAmenityDetailModal}
                                                >
                                                    <AmenityDetailModal />
                                                </Modal>

                                                <Content>
                                                    {/* Header */}
                                                    <Row>
                                                        <Col
                                                            span={24}
                                                            className='stm-position-fixed stm-top-0 stm-z-index-100000 stm-max-width-500'
                                                            style={{
                                                                fontFamily: activeTemplate.templateSetting.header.fontFamily,
                                                                background: activeTemplate.templateSetting.header.backgroundColor,
                                                                color: activeTemplate.templateSetting.header.color,
                                                                fontSize: activeTemplate.templateSetting.header.fontSize,
                                                                lineHeight: `${activeTemplate.templateSetting.header.fontSize + 2}px`
                                                            }}
                                                        >
                                                            <Row>
                                                                <Col span={4} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50' onClick={this.back}>
                                                                    <Icon type='left' size='lg' color={activeTemplate.templateSetting.header.color} />
                                                                </Col>
                                                                <Col span={16} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50'>
                                                                    {menu ? menu.taskName : ''}
                                                                </Col>
                                                                <Col span={4} />
                                                            </Row>
                                                        </Col>
                                                    </Row>

                                                    {/* Body */}
                                                    <>
                                                        {
                                                            amenityTabCategories.length === 0 && amenityItems.length === 0
                                                                ?
                                                                <>
                                                                    <Row>
                                                                        <Col span={24} className='stm-margin-top-150 stm-text-align-center'>
                                                                            <Spin
                                                                                spinning={true}
                                                                                tip={webSettting.loadingDataText}
                                                                                style={{
                                                                                    fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                    color: activeTemplate.templateSetting.text.color,
                                                                                    fontSize: activeTemplate.templateSetting.text.fontSize
                                                                                }}>
                                                                            </Spin>
                                                                        </Col>
                                                                    </Row>
                                                                </>
                                                                :
                                                                <Row>
                                                                    <Col span={24} className='stm-margin-top-50'>
                                                                        <Tabs
                                                                            activeKey={amenityTabCategoryIdActive}
                                                                            className='stm-tab'
                                                                            type='line'
                                                                            onTabClick={this.tabClick}
                                                                            style={{
                                                                                fontFamily: activeTemplate.templateSetting.tab.fontFamily,
                                                                                color: activeTemplate.templateSetting.tab.color,
                                                                                fontSize: activeTemplate.templateSetting.tab.fontSize,
                                                                                lineHeight: `${activeTemplate.templateSetting.tab.fontSize + 2}px`
                                                                            }}
                                                                        >
                                                                            {
                                                                                amenityTabCategories.map((tab) => {
                                                                                    let itemFilters = amenityFilterItems.filter(fi => fi.categoryId === tab.taskId);

                                                                                    return (
                                                                                        <TabPane tab={tab.taskName} key={tab.taskId} className='stm-tabpane'>
                                                                                            {/* Category Description */}
                                                                                            <>
                                                                                                {
                                                                                                    tab.taskDesc === null || tab.taskDesc === ''
                                                                                                        ?
                                                                                                        null
                                                                                                        :
                                                                                                        <Row className='stm-tab-description-container'>
                                                                                                            <Col span={24} className='stm-tab-description'>
                                                                                                                <Row>
                                                                                                                    <Col span={3} className='stm-tab-description-image'>
                                                                                                                        <img src={require('../../assets/image/Icon/HelpInfo.svg')} alt='HelpInfo' className='stm-item-desc-image' />
                                                                                                                    </Col>
                                                                                                                    <Col
                                                                                                                        span={21}
                                                                                                                        className='stm-tab-description-text'
                                                                                                                        style={{
                                                                                                                            fontFamily: activeTemplate.templateSetting.buttonItem.fontFamily,
                                                                                                                            fontSize: activeTemplate.templateSetting.buttonItem.fontSize - 2,
                                                                                                                            lineHeight: `${activeTemplate.templateSetting.buttonItem.fontSize}px`,
                                                                                                                            color: activeTemplate.templateSetting.buttonItem.color
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <Markup content={tab.taskDesc} />
                                                                                                                    </Col>
                                                                                                                </Row>
                                                                                                            </Col>
                                                                                                        </Row>
                                                                                                }
                                                                                            </>

                                                                                            <Row className='stm-tab-filter-container'>
                                                                                                <Col span={24} className='stm-tab-filter'>
                                                                                                    <Search
                                                                                                        placeholder={webSettting.searchText}
                                                                                                        value={amenitySearchText}
                                                                                                        onChange={this.searchText}
                                                                                                    />
                                                                                                </Col>
                                                                                                <React.Fragment>
                                                                                                    {
                                                                                                        amenityTabSubCategories.length > 0
                                                                                                            ?
                                                                                                            <Col span={24} className='stm-tab-filter'>
                                                                                                                <Picker
                                                                                                                    data={[amenityTabSubCategories]}
                                                                                                                    title='Select Sub Category'
                                                                                                                    cascade={false}
                                                                                                                    value={[amenitySearchSubCategory]}
                                                                                                                    okText={webSettting.okText}
                                                                                                                    dismissText={webSettting.cancelText}
                                                                                                                    onOk={this.selectBySubCategory}
                                                                                                                >
                                                                                                                    <List.Item>
                                                                                                                        <Row className='stm-margin-bottom-2'>
                                                                                                                            <Col span={24} className='stm-list-category'>
                                                                                                                                <Row
                                                                                                                                    className='stm-width-100-percent'
                                                                                                                                    style={{
                                                                                                                                        fontFamily: activeTemplate.templateSetting.buttonItem.fontFamily,
                                                                                                                                        fontSize: activeTemplate.templateSetting.buttonItem.fontSize,
                                                                                                                                        lineHeight: `${activeTemplate.templateSetting.buttonItem.fontSize + 2}px`,
                                                                                                                                        color: activeTemplate.templateSetting.buttonItem.color,
                                                                                                                                        backgroundColor: activeTemplate.templateSetting.buttonItem.backgroundColor
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    <Col span={20}>
                                                                                                                                        {amenitySearchSubCategory}
                                                                                                                                    </Col>
                                                                                                                                    <Col span={4} className='stm-text-align-right stm-padding-right-10'>
                                                                                                                                        <img src={require('../../assets/image/Icon/Arrow-Down.svg')} alt='Arrow-Down' className='stm-width-16 stm-height-16' />
                                                                                                                                    </Col>
                                                                                                                                </Row>
                                                                                                                            </Col>
                                                                                                                        </Row>
                                                                                                                    </List.Item>
                                                                                                                </Picker>
                                                                                                            </Col>
                                                                                                            :
                                                                                                            null
                                                                                                    }
                                                                                                </React.Fragment>
                                                                                            </Row>

                                                                                            <div
                                                                                                onTouchStart={(e) => this._onTouchStart(e, this)}
                                                                                                onTouchMove={(e) => this._onTouchMove(e, this)}
                                                                                                onTouchEnd={(e) => this._onTouchEnd(e, this, tab.taskId)}>
                                                                                                <AmenityTabPage items={itemFilters} />
                                                                                            </div>
                                                                                        </TabPane>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </Tabs>
                                                                    </Col>
                                                                </Row>
                                                        }
                                                    </>

                                                    {/* Footer */}
                                                    <Row>
                                                        <Col
                                                            span={24}
                                                            className='col-body-footer-next'
                                                            style={{
                                                                background: activeTemplate.templateSetting.footer.backgroundColor,
                                                                fontFamily: activeTemplate.templateSetting.footer.fontFamily,
                                                                fontSize: activeTemplate.templateSetting.footer.fontSize,
                                                                lineHeight: `${activeTemplate.templateSetting.footer.fontSize + 2}px`,
                                                                color: activeTemplate.templateSetting.footer.color
                                                            }}
                                                        >
                                                            <Row>
                                                                <Col span={4} className='col-body-footer-next-left'>
                                                                    <img src={basketImage} alt='basket' />
                                                                </Col>
                                                                <Col span={8} className='col-body-footer-next-center'>
                                                                    {amenityTotalOrder} {webSettting.itemText}
                                                                </Col>
                                                                <Col span={9} className='col-body-footer-next-right-text' onClick={this.goToConfirmPage}>
                                                                    {webSettting.nextText}
                                                                </Col>
                                                                <Col span={3} className='col-body-footer-next-right' onClick={this.goToConfirmPage}>
                                                                    <Icon type='right' size='lg' color='#fff' />
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Content>
                                            </>
                                            :
                                            null
                                    }
                                </>
                            </Layout>
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default AmenityMainPage;